export default __webpack_public_path__ + "static/15-f83674fe37f87da92d6abb733142c8d5.jpg";